import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyOrderStatusBar, { BuyOrderStatusBarNew, CreateStatusBarProps } from '../../../BuyOrderStatusBar'
import BuyOrderCreateStepButtons, { BuyOrderCreateStepButtonsNew } from '../BuyOrderCreateStepButtons'

type BuyOrderCreateStepHeaderProps = & CreateStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyOrderCreateStepHeaderDecider: React.FC<BuyOrderCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyOrderCreateStepHeaderDefault} NewComponent={BuyOrderCreateStepHeaderNew} {...rest} />
    )
}

const BuyOrderCreateStepHeaderDefault: React.FC<BuyOrderCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyOrderStatusBar {...rest} />
            <BuyOrderCreateStepButtons {...rest} />
        </div>
    )
}

const BuyOrderCreateStepHeaderNew: React.FC<BuyOrderCreateStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyOrderStatusBarNew {...rest} />
            <BuyOrderCreateStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyOrderCreateStepHeaderDecider